<template>
  <v-container class="py-0">
    <v-form 
      v-model="base_form" 
      ref="base"
      lazy-validation
      @submit.prevent="updateBaseForm"
    >
      <v-row
        v-for="question in mean_info" 
        class="py-2"
        style="border-bottom: 1px #f3f3f3 solid;"
        align="center"
      >
        <v-col class="py-0 pr-4 text-left">
          {{question.question}}
        </v-col>
        <div class="float-right mx-3">
          <v-text-field
            outlined
            class="mt-0 width-field"
            type="number"
            :rules="[v =>  !!v || 'Valor requerido']"
            :label="question.key"
            :readonly="!is_ies || !editable"
            v-model="ies_year_data.register_referance[question.short_key]"
          ></v-text-field>
        </div>
      </v-row>
      <v-row>
        <v-col cols="8" class="pb-0 pt-1">
          <v-tooltip bottom v-if="ies_year_data.register_referance.organigrama">
            <template v-slot:activator="{ on }">
              <v-chip
                class="mx-2 mt-2"
                close
                v-on="on"
                text-color="red"
                color="teal lighten-5"
                :close-icon="is_ies && editable ? 'mdi-delete' : ''"
                @click="downloadOrgani"
                @click:close="trashOrgani"
              >
                <v-avatar left>
                  <v-icon color="blue-grey">attachment</v-icon>
                </v-avatar>
                <span class="blue-grey--text" style="max-width: 222px">
                  {{ies_year_data.register_referance.organigrama_name.substr(0,25)}}
                </span>
              </v-chip>
            </template>
            <span>{{ ies_year_data.register_referance.organigrama_name}} </span>
          </v-tooltip>
          <template v-else>
            <input type="file" id="elorgani" style="display:none" @change="updateOrganigrama">
            <v-btn class="mt-2" outlined color="blue-grey" @click="uploadIndirect">
              <v-icon left>attach_file</v-icon> Subir Organigrama
            </v-btn>
          </template>
        </v-col>
        <v-col align="end" justify="center" v-if="is_ies && editable">
          <v-btn @click="updateBaseForm" color="success" :disabled="!base_form">
            Guardar números
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog
      v-model="dialog"
      max-width="350"
    >
      <v-card>
        <v-card-title class="headline">¿De verdad quieres eliminar el organigrama?</v-card-title>
        <v-card-text>
          Una vez eliminado no lo podrás recuperar
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            No eliminar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="deleteOrgani"
          >
            Sí eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>

import { mapState } from "vuex";

export default {
  name: 'BaseInfo',
  data(){
    return {
      dialog: false,
      base_form: undefined,
      mean_info:[
        {
          "question":"Número de entidades académicas de acuerdo con el organigrama de la institución:",
          "short_key":"ent_acad",
          "key":"entidades academicas",
        },
        {
          "question":"Número de dependencias administrativas de acuerdo con el organigrama de la institución:",
          "short_key":"dep_admin",
          "key":"dependencias administrativas",
        },
        {
          "question":"Número de planes de estudio de licenciatura y/o posgrado",
          "short_key":"planes_est",
          "key":"planes de estudio",
        },
      ],
    }
  },
  methods:{
    updateBaseForm() {
      //console.log(this.$refs)
      if (this.$refs.base.validate()){
        const base_data = Object.keys(this.ies_year_data.register_referance)
          //.filter(key => this.mean_info.some(x=>x.short_key == key))
          .reduce((obj, key) => {
            if (this.mean_info.some(x=>x.short_key==key)) 
              obj[key] = this.ies_year_data.register_referance[key];  
            return obj;
          }, {});
        this.$store
          .dispatch('UPDATE_PERIOD_IES_BASE', {data:base_data, 
            period_ies_id:this.ies_year_data.ies_period_id,
            snack_text: "Información Base actualizada"})
          .then((data) => {
            //console.log(data)
          })
          .catch(error =>
            console.log(error)
          );
      }
    },
    updateOrganigrama(e){
      let formData = new FormData();
      var files = e.target.files || e.dataTransfer.files;
      formData.append("organigrama", files[0], files[0].name);
      //console.log(files[0])
      this.$store
        .dispatch('UPDATE_PERIOD_IES_BASE', {data: formData,
          period_ies_id: this.ies_year_data.ies_period_id,
          snack_text: "Se añadió el organigrama"})
        .then((data) => {
          //console.log(data)
        })
        .catch(error =>
          console.log(error)
        );
    },
    uploadIndirect(){
      document.getElementById('elorgani').click();
    },
    trashOrgani(){
      this.dialog = true;
    },
    deleteOrgani(){
      this.$store
        .dispatch('UPDATE_PERIOD_IES_BASE', {data:{organigrama:null},
          period_ies_id:this.ies_year_data.ies_period_id, 
          snack_text:"El organigrama fue eliminado"})
        .then((data) => {
          //console.log(data)
        })
        .catch(error =>
          console.log(error)
        );
      this.dialog = false;
    },
    downloadOrgani(){
      window.open(this.ies_year_data.register_referance.organigrama, '_blank');
      //window.open("http://165.227.212.99:5000/media/Maximo_documento_normativo.docx", '_blank');
    },
  },
  computed:{
    ...mapState({
      ies_year_data: state => state.ies_year_data,
      is_ies: state => state.is_ies,
      editable: state => state.ies_year_data.register_referance.status.can_ies_change,
    }),
  },
}
</script>


<style lang="scss" scoped>
.width-organi{
  width: 200px;
}
</style>